module.exports = __webpack_public_path__ + "static/smimgfm-ebc42ead4e6d4452ca6f0a30b2d04185.png";